import { create } from 'zustand';
import { getComponentStore } from '../../utils/componentStoreRegistry';

const createAPIResReqSaveStore = () => create((set, get) => ({
  loaded: false,
  save: null,
  registerSave: (fn) => set({ save: fn }),
  unregisterSave: () => set({ save: null }),
}));

export function getAPIResReqSaveStore(componentId) {
  return getComponentStore('api-res-req-save', componentId, createAPIResReqSaveStore);
}
